export const mapDataForChart = rawData =>
  Object.entries(rawData).map(([date, dataItem]) => ({
    ...dataItem,
    date,
    numberOfEmployeesWorked: dataItem.number_of_employees_worked,
    numberOfEmployeesPlanned: dataItem.number_of_employees_planned,
    number_of_employees_worked: undefined,
    number_of_employees_planned: undefined,
  }));
